import * as React from "react";
import { InputNumber } from "antd";
import { InputNumberProps } from "antd/lib/input-number";

type ValueType = number | string;

/**
 * Стандартный компонент для числового ввода
 * Учитывается precision. Для целочисленных полей нужно указывать precision=0
 * @param props Пропсы от компонента InputNumber
 * @constructor
 */
export const InputNumberStd = React.forwardRef(
  <T extends ValueType = ValueType>(
    props: InputNumberProps<T>,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => <InputNumber<T> ref={ref} {...props} parser={parser} wheel={false} />,
);

const parser = <T extends ValueType>(value: string | undefined): T =>
  (value?.replace(",", ".") ?? "") as T;
